export default __webpack_public_path__ + "static/media/profile.b029cfca.svg";